import { SimpleCallback } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { ConfirmationDialog } from 'common.components/confirmation-dialog/confirmation-dialog';

import * as actions from './actions';
import { getShouldShowClosingLessonModal } from './selectors';

interface StoreProps {
    shouldShowModal: boolean;
}

interface DispatchProps {
    confirmLessonClosing: SimpleCallback;
    cancelLessonClosing: SimpleCallback;
}

interface ClosingLessonModalProps extends StoreProps, DispatchProps {}

export class ClosingLessonModal extends React.PureComponent<ClosingLessonModalProps> {
    render() {
        const { cancelLessonClosing, confirmLessonClosing, shouldShowModal } = this.props;

        if (!shouldShowModal) {
            return null;
        }

        return (
            <ConfirmationDialog
                closable
                confirmLabelId="closeLessonModal.submit"
                messageId="closeLessonModal.description"
                messageType={TEXT_MARKUP_TYPE.HTML}
                onClose={cancelLessonClosing}
                onConfirm={confirmLessonClosing}
                onReject={cancelLessonClosing}
                opened
                rejectLabelId="closeLessonModal.cancel"
            />
        );
    }
}

const mapStateToProps = (storeState: any): StoreProps => ({
    shouldShowModal: getShouldShowClosingLessonModal(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    const { confirmLessonClosing, cancelLessonClosing } = actions;

    return bindActionCreators(
        {
            confirmLessonClosing,
            cancelLessonClosing,
        },
        dispatch
    );
};

const wrapped = connect(mapStateToProps, mapDispatchToProps)(ClosingLessonModal);
wrapped.displayName = 'ClosingLessonModal';

export default wrapped;
